import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import { DatePickerNew, Input, Select } from 'common-src/components/base';
import {
  AssessmentTypeOptions,
  ClinicianAttestationOptions,
  NursingHomeStatusOptions,
  ResidenceTypeOptions,
  validatePatientGuideCmsAlignment,
} from 'common-src/models/PatientGuideCmsAlignment';
import { ColorsNew } from 'common-src/styles';

const AnnualAssessment = ({ data, handleInputChange, errors, setErrors }) => (
  <>
    <Select
      id="assessment-type"
      label="Assessment type"
      options={AssessmentTypeOptions}
      onChange={(op) => handleInputChange('assessmentType', op.value)}
      value={AssessmentTypeOptions.find((op) => op.value === data.assessmentType)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
    />
    <DatePickerNew
      id="assessment-date"
      header="Assessment date"
      placeholder="Select date"
      value={data.assessmentDate}
      onDateSelected={(date) =>
        handleInputChange('assessmentDate', date ? moment(date).format('YYYY-MM-DD') : null)
      }
      onBlur={(date) =>
        setErrors((prev) => ({
          ...prev,
          ...validatePatientGuideCmsAlignment('assessmentDate', date),
        }))
      }
      errorText={errors.assessmentDate}
      required
      requiredColor={ColorsNew.mediumDarkRed}
      maxDate={new Date()}
    />
    <Select
      id="clinician-attestation"
      label="Clinician attestation"
      placeholder="Select"
      options={ClinicianAttestationOptions}
      onChange={(op) => handleInputChange('clinicianAttestation', op.value)}
      value={ClinicianAttestationOptions.find((op) => op.value === data.clinicianAttestation)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
    />
    <Select
      id="nursing-home-status"
      label="Nursing home status"
      placeholder="Select"
      options={NursingHomeStatusOptions}
      onChange={(op) => handleInputChange('nursingHomeStatus', op.value)}
      value={NursingHomeStatusOptions.find((op) => op.value === data.nursingHomeStatus)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
    />
    <Select
      id="residence-type"
      label="Residence type"
      placeholder="Select"
      options={ResidenceTypeOptions}
      onChange={(op) => handleInputChange('residenceType', op.value)}
      value={ResidenceTypeOptions.find((op) => op.value === data.residenceType)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
    />
    <Input
      id="npi"
      placeholder="NPI"
      label="NPI"
      value={data.npi ?? ''}
      onTextChange={(value) => handleInputChange('npi', value)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
      errorText={errors.npi}
      tooltipText="Attesting (diagnosing) provider NPI"
    />
    <Input
      id="clinician-first-name"
      placeholder="First name"
      label="Clinician first name"
      value={data.clinicianFirstName ?? ''}
      onTextChange={(value) => handleInputChange('clinicianFirstName', value)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
      errorText={errors.clinicianFirstName}
      tooltipText="Attesting (diagnosing) provider first name"
    />
    <Input
      id="clinician-middle-name"
      placeholder="Middle name"
      label="Clinician middle name"
      value={data.clinicianMiddleName ?? ''}
      onTextChange={(value) => handleInputChange('clinicianMiddleName', value)}
      errorText={errors.clinicianMiddleName}
      tooltipText="Attesting (diagnosing) provider middle name"
    />
    <Input
      id="clinician-last-name"
      placeholder="Last name"
      label="Clinician last name"
      value={data.clinicianLastName ?? ''}
      onTextChange={(value) => handleInputChange('clinicianLastName', value)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
      errorText={errors.clinicianLastName}
      tooltipText="Attesting (diagnosing) provider last name"
    />
  </>
);

AnnualAssessment.propTypes = {
  data: PropTypes.object,
  handleInputChange: PropTypes.func,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
};

export default AnnualAssessment;
